import React, { useState, createContext, useCallback } from 'react'
import { Menu as MenuIcon } from '@material-ui/icons'
import { useMediaQuery, Drawer, Divider } from '@material-ui/core'

import * as medias from '@/consts/medias'
import { colors } from '@/theme'
import { useProfile } from '@/hooks'

import { SignoutButton } from '../AppBar'
import { CarrierMenuItems } from './profiles/Carrier'
import { AdminMenuItems } from './profiles/Admin'
import { DeveloperMenuItems } from './profiles/Developer'

import { Container, StyledButton } from './styles'
import { company } from '@/consts/types'
import { RepresentativeMenuItems } from './profiles/Representative'
import { CustomerMenuItems } from './profiles/Customer'

// --------------- ℂ𝕠𝕞𝕡𝕠𝕟𝕖𝕟𝕥𝕤 ---------------

export const DrawerContext = createContext(null)

// --------------- 𝕄𝕒𝕚𝕟 ---------------

export function MenuItems() {
  const md = useMediaQuery(medias.md)

  const profile = useProfile()

  const [showMenu, setshowMenu] = useState(false)

  const open = useCallback(() => setshowMenu(true), [])

  const close = useCallback(() => setshowMenu(false), [])

  function renderMenuItems() {
    const companyRole = profile.web_company.wee_tipo

    switch (companyRole) {
      case company.ECOSIS:
        return <DeveloperMenuItems />

      case company.ADMIN:
        return <AdminMenuItems />

      case company.TRANSPORTADORA:
        return <CarrierMenuItems />

      case company.REPRESENTANTE:
        return <RepresentativeMenuItems />

      case company.CLIENTE:
        return <CustomerMenuItems />

      default:
        return null
    }
  }

  return md ? (
    <DrawerContext.Provider value={{ show: showMenu, open, close }}>
      <StyledButton onClick={open}>
        <MenuIcon />
      </StyledButton>

      <Drawer
        anchor="left"
        open={showMenu}
        onClose={close}
        PaperProps={{
          style: {
            background: colors.colorAppBar,
            width: '50%',
          },
        }}
      >
        {renderMenuItems()}
        <Divider />
        <SignoutButton className="MenuItem" />
      </Drawer>
    </DrawerContext.Provider>
  ) : (
    <Container>{renderMenuItems()}</Container>
  )
}

export default MenuItems
